import React, { useEffect, useState } from 'react'
import * as web3Service from '../../../blockchain/web3.service'
import { DateTime } from 'luxon'
import { Spin, Button } from 'antd'
import Countdown from 'react-countdown'
import { GiftOutlined } from '@ant-design/icons'
import { useWeb3React } from '@web3-react/core'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventEmitter from '../../../Utils/EventEmitter'
export default function SellDragonsButton(props) {

  const { accountAddress } = props
  const [isWithdrawalTaxAvailable, setIsWithdrawalTaxAvailable] = useState(false)
  const [lastHatchTimestamp, setLastHatchTimestamp] = useState(null)
  const [withdrawalTax, setWithdrawalTax] = useState(0)
  const [withdrawalCoolDown, setWithdrawalCoolDown] = useState(0)
  const [isLoading, setIsLoading] = useState(0)
  const [isWithdrawalOnHold, setIsWithdrawalOnHold] = useState(true)
  const [coolDownTimer, setCoolDownTimer] = useState(null)
  const [isSellDragonLoading, setIsSellDragonLoading] = useState(false)
  const [logs, setLogs] = useState(null)

  useEffect(() => {
    const onNewLogs = (eventData) => {
      setLogs(eventData)
    }
    const listener = EventEmitter.addListener('HireDragonEvent', onNewLogs)
    return () => {
      listener.remove()
    }
  }, [])


  const { account, library } = useWeb3React()

  useEffect(() => {
    if (accountAddress) {
      fetchAllTheDataForCalculation(accountAddress)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountAddress, logs])


  const fetchAllTheDataForCalculation = async (accountAddress) => {
    setIsLoading(true)
    await calculateSellTax()
    await fetchWithdrawalCoolDown()
    await checkTaxWithdrawalAvailability(accountAddress)
    setIsLoading(false)
  }

  const calculateSellTax = async () => {
    try {
      const sellTaxResponse = await web3Service.getWithdrawalTax()
      if (sellTaxResponse) {
        setWithdrawalTax(sellTaxResponse)
      } else {
        setWithdrawalTax(0)
      }
    } catch (error) {
      setWithdrawalTax(0)
      console.error("ERROR Sell dragon button component sell tax error ", error)
    }
  }

  const checkTaxWithdrawalAvailability = async (accountAddress) => {
    try {
      const userDetailsResponse = await web3Service.getDragonDetailsByUserAddress(accountAddress)
      if (userDetailsResponse && userDetailsResponse.lastHatchTimestamp) {
        setLastHatchTimestamp(parseInt(userDetailsResponse.lastHatchTimestamp))
      } else {
        setLastHatchTimestamp(null)
      }

      if (userDetailsResponse && userDetailsResponse.dailyCompoundBonus) {
        const dailyCompoundBonusInt = parseInt(userDetailsResponse.dailyCompoundBonus)
        const compoundCountResponse = await web3Service.getTxCompoundCount()
        const compoundCountInt = parseInt(compoundCountResponse)
        if (parseInt(dailyCompoundBonusInt) < parseInt(compoundCountInt)) {
          setIsWithdrawalTaxAvailable(true)
        } else {
          setIsWithdrawalTaxAvailable(false)
        }

      } else {
        setIsWithdrawalTaxAvailable(false)
      }
    } catch (error) {
      setWithdrawalTax(0)
      console.error("ERROR Sell dragon button component tax withdrawal availability ", error)
    }
  }

  const fetchWithdrawalCoolDown = async () => {
    try {
      const withdrawalCoolDownResponse = await web3Service.getWithdrawalCoolDownTime()
      if (withdrawalCoolDownResponse) {
        setWithdrawalCoolDown(withdrawalCoolDownResponse)
      } else {
        setWithdrawalCoolDown(0)
      }

    } catch (error) {
      setWithdrawalCoolDown(0)
      console.error("ERROR Sell dragon button component withdrawal cool down ", error)
    }
  }

  useEffect(() => {
    if (lastHatchTimestamp && withdrawalCoolDown) {
      const coolDownTimePeriod = parseInt(lastHatchTimestamp) + parseInt(withdrawalCoolDown)
      const diff = coolDownTimePeriod - parseInt(DateTime.now().toSeconds())

      if (diff > 0) {
        setIsWithdrawalOnHold(true)
        const coolDownTimerInMills = DateTime.fromSeconds(coolDownTimePeriod).toMillis()
        setCoolDownTimer(coolDownTimerInMills)
      } else {
        setIsWithdrawalOnHold(false)
        setCoolDownTimer(null)
      }
    } else {
      setIsWithdrawalOnHold(false)
    }

  }, [lastHatchTimestamp, withdrawalCoolDown, account])

  const handleSellDragon = async () => {
    try {
      setIsSellDragonLoading(true)
      //check if user logged into the system
      if (!account) {
        toast.error("Please connect your wallet to continue")
        setIsSellDragonLoading(false)
        return
      }

      const response = await web3Service.sellDragons(library.getSigner())
      toast.success("Dragon sell process has been completed")
      console.log(response)
      setIsSellDragonLoading(false)

    } catch (error) {
      let errorMessage = "Something went wrong"
      if (error && error.message) {
        errorMessage = error.message
      }

      if (error && error.data) {
        errorMessage = error.data.message
      }
      toast.error(errorMessage)
      setIsSellDragonLoading(false)
    }
  }

  const renderer = ({ days, hours, minutes, seconds }) => {

    let totalHours = 0
    let totalMinutes = minutes
    let totalSeconds = seconds

    if (parseInt(days) >= 1) {
      totalHours = parseInt(hours) + parseInt(days) * 24
    } else {
      totalHours = parseInt(hours)
    }

    if (parseInt(totalHours) < 10) { totalHours = '0' + totalHours; }
    if (parseInt(totalMinutes) < 10) { totalMinutes = '0' + totalMinutes; }
    if (parseInt(totalSeconds) < 10) { totalSeconds = '0' + totalSeconds; }

    return <span>{totalHours}h:{totalMinutes}m:{totalSeconds}s</span>
  };


  return (
    <div>
      {
        isLoading ? (
          <div className='d-flex justify-content-center loading-container'>
            <Spin style={{ color: 'red' }} size="small" />
          </div>
        ) : (
          <Button
            block
            onClick={handleSellDragon}
            className='hiring-dragons-btn'
            loading={isSellDragonLoading}
            type="primary"
            disabled={isWithdrawalOnHold}
            shape="round"
            icon={<GiftOutlined />}
            size="large">
            Sell Dragons <span className='cool-down-timer'>{isWithdrawalOnHold && coolDownTimer > 0 ? <Countdown
              date={coolDownTimer}

              renderer={renderer}
              daysInHours={true}
            /> : ''}  </span>{isWithdrawalTaxAvailable ? ('(-' + withdrawalTax + '%)') : ''}
          </Button>
        )
      }

    </div>
  )
}
